<template>
  <div class="top-pic-wrap">
    <div class="pc-show">
      <img src="../../static/imgs/pc/home-pic2.png"
           alt="">
    </div>
    <div class="phone-show"
         style="position: relative;">
      <img src="../../static/imgs/phone/home_pic.png"
           alt="">
      <!-- <video controls="controls"
             muted
             loop
             autoplay="autoplay"
             :src="videoUrl">
      </video> -->

      <div class="home-slide phone-show">
      </div>
    </div>

    <div class="top-title">
      <h3>修复旧照片<br />梦回好时光</h3>

      <div class="home-download pc-show">
        <span @click="iosLoad">iOS下载</span>
        <span @click="anzhuoLoad">安卓下载</span>
      </div>

      <div class="home-download phone-show"
           @click="download">
        <span>立即下载</span>
      </div>

      <div class="top-txt">
        <span>AI人像翻新</span>
        <span>人工修复</span>
        <span>创意修复</span>
        <span>照片恢复</span>
      </div>
    </div>

    <div class="top-qrcode pc-show">
      <img src="../../static/imgs/pc/home-qrcode.png"
           alt="">
      <!-- <p>立即扫码下载</p> -->
    </div>

  </div>
</template>

<script>
export default {
  name: 'home-top',
  data () {
    return {
      // 是否ios
      isIOS: false,
      iosUrl: "https://apps.apple.com/cn/app/id1497453325",
      anzhuoUrl: "https://a.app.qq.com/o/simple.jsp?pkgname=com.puwu.rephoto",
      anzhuoApk: "https://oss.puwu.info/rephoto/update/照片修复.apk",
      videoUrl: require("../../static/imgs/young1.mp4")
    }
  },
  mounted () {
    let ua = navigator.userAgent.toLowerCase();
    this.isIOS = ua.indexOf('mac os') > -1;
  },
  methods: {
    iosLoad () {
      //   location.href = this.iosUrl;
      window.open(this.iosUrl, '_blank');
    },
    anzhuoLoad () {
      //   location.href = this.anzhuoUrl;
      window.open(this.anzhuoUrl, '_blank');
    },
    download () {
      let goUrl = this.isIOS ? this.iosUrl : this.anzhuoApk;
      window.open(goUrl, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
@import "./home-top.less";
</style>